"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicLeaderboardContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const draw_1 = require("../draw");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.publicLeaderboardContract = c.router({
    getCurrentLeaderboardDraw: {
        method: 'GET',
        path: '/current',
        responses: {
            200: zod_1.z.object({
                draw: zod_1.z.object({
                    draw_type: draw_1.ZDrawTypeSelect,
                    draw_schedule: draw_1.ZDrawScheduleSelect,
                    draw: draw_1.ZDrawSelect,
                    prize: models_1.ZLeaderboardPrizeDetails,
                }),
            }),
            404: c.type(),
        },
    },
    getLeaderboardRanking: {
        method: 'GET',
        path: '/ranking',
        query: zod_1.z.object({
            draw_id: zod_1.z.coerce.number().optional(),
            limit: zod_1.z.optional(zod_1.z.coerce.number()),
        }),
        responses: {
            200: zod_1.z.object({
                leaderboard: zod_1.z
                    .object({
                    position: zod_1.z.number(),
                    positionLeaderboardRows: zod_1.z
                        .object({
                        rank: zod_1.z.number(),
                        leaderboard_username: zod_1.z.string().nullable(),
                        leaderboard_photo_location: zod_1.z.string().nullable(),
                        initials: zod_1.z.string().nullable(),
                        points: zod_1.z.number(),
                    })
                        .array(),
                })
                    .array(),
            }),
            400: c.type(),
        },
    },
    getPointsBreakdown: {
        method: 'GET',
        path: '/points-breakdown',
        query: zod_1.z.object({ user_id: zod_1.z.string() }),
        responses: {
            200: zod_1.z.object({
                breakdown: zod_1.z.array(zod_1.z.object({
                    id: zod_1.z.string(),
                    created_at: zod_1.z.date(),
                    points: zod_1.z.number(),
                })),
            }),
            400: c.type(),
        },
    },
    getPointsTotalForUser: {
        method: 'GET',
        path: '/points-total',
        query: zod_1.z.object({ user_id: zod_1.z.string() }),
        responses: {
            200: zod_1.z.object({ pointsTotal: zod_1.z.number() }),
            400: c.type(),
        },
    },
    getLastMonthsWinners: {
        method: 'GET',
        path: '/last-months-winners',
        responses: {
            200: zod_1.z.object({
                success: zod_1.z.boolean(),
                data: zod_1.z
                    .object({
                    drawDate: zod_1.z.coerce.date().nullable(),
                    prize: models_1.ZLeaderboardPrizeDetails,
                    positionWinners: zod_1.z.array(zod_1.z.object({
                        rank: zod_1.z.number(),
                        leaderboard_username: zod_1.z.string().nullable(),
                        leaderboard_photo_location: zod_1.z.string().nullable(),
                        initials: zod_1.z.string(),
                        points: zod_1.z.number(),
                    })),
                    raffleWinner: zod_1.z
                        .object({
                        leaderboard_username: zod_1.z.string().nullable(),
                        leaderboard_photo_location: zod_1.z.string().nullable(),
                        initials: zod_1.z.string(),
                    })
                        .nullable(),
                })
                    .nullable(),
            }),
        },
    },
}, {
    pathPrefix: '/public',
    strictStatusCodes: true,
});
//# sourceMappingURL=leaderboard.public.contract.js.map